'use client';
import React from "react";

import { css, Global } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useAppTheme } from "./ThemeContextProvider";

// CSS custom-property groups generated from the theme's color tokens (see muiTheme.js).
// Any *.css file can consume these via var(--os-<group>-<key>) instead of hardcoding colors.
const CSS_VAR_GROUPS = [
  'kontram', 'status', 'heatmap', 'dashboard', 'surface', 'staticText',
  'topBar', 'gauge', 'graphicalDevice', 'devPanel', 'map', 'sensorTable',
];

const toKebabCase = (value) => value.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

const paletteGroupToCssVars = (groupName, group) => {
  if (!group || typeof group !== 'object') return '';
  return Object.entries(group)
    .map(([key, value]) => `--os-${toKebabCase(groupName)}-${toKebabCase(key)}: ${value};`)
    .join('\n');
};

export default function ThemeWrapper({ children }) {

  const { muiTheme } = useAppTheme();

  const cssVars = CSS_VAR_GROUPS
    .map((groupName) => paletteGroupToCssVars(groupName, muiTheme.palette[groupName]))
    .join('\n');

  // Theme-aware scrollbar styles
  const scrollbarStyles = css`
   :root {
     ${cssVars}
   }
   ::-webkit-scrollbar {
     width: 4px;
     height: 4px;
     background: ${muiTheme.palette.background.scrollbarTrack};
   }
   ::-webkit-scrollbar-track {
     background: transparent;
   }
   ::-webkit-scrollbar-thumb {
      background: ${muiTheme.palette.primary.main};
      border-radius: 4px;
   }
 `;

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Global styles={scrollbarStyles} />
      {children}
    </ThemeProvider>
  );
}


